import axios from "axios";
import { stnames } from "../../pages/_app";
import JwtService from "../../services/JwtService";

export const sendLead = async (formData, callViability, featureFlag) => {
    try {
        const tvId = sessionStorage.getItem('tvId') || [];
        const ACN = sessionStorage.getItem(stnames.acn) === 'true'
        let viabilityInfo = {}
        if (callViability) {
            viabilityInfo = await getViability(formData.cep, formData.number);

            const hasCable = !!viabilityInfo.technologies.find(tech => tech.name === 'Cable');
        }

        const leadObj = mountLeadObject(tvId, formData, viabilityInfo, ACN)
        const payload = await JwtService.objectToPayloadToken(leadObj)
        const response = await axios.post(`${process.env.baseApiURL}/api/leads`, payload);
        if (response.status === 200 || response.status === 201) {            
            const leadId = findAttribute(response, "id")         
            return leadId;
        } else {
            throw new Error("Erro ao enviar o formulário");
        }
    } catch (error) {
        console.error("Erro ao enviar o formulário:", error.response ? error.response.data : error);
        return { "error": error }
    }
};

export const getLead = async (leadId) => {
    try {      
        const response = await axios.get(`${process.env.baseApiURL}/api/leads`, { headers: {'lead_id': leadId} });   
        if (response.status === 200) {
            return responseData.data;
        } else {
            throw new Error("Erro ao buscar o lead");
        }
    } catch (error) {
        console.error("Erro ao buscar o lead:", error.response ? error.response.data : error);
        return { "error": error }
    }
};

const getViability = async (cep, number) => {
    const AVAILABLE_TECHNOLOGIES_RESPONSE_SESSION_NAME = 'available_technologies_response';
    const storage = sessionStorage.getItem(AVAILABLE_TECHNOLOGIES_RESPONSE_SESSION_NAME);

    var jwt = require('jsonwebtoken');

    if (!!storage) {
        const viabilityStorage = jwt.decode(storage)
  
        const cepStorage = viabilityStorage?.data?.cep;
        const numberStorage = viabilityStorage?.data?.number;
  
        if (cepStorage === cep && numberStorage === number) {
          return viabilityStorage?.data
        }
    }

    try {
        if (number === "SN" || number === '') {
            number = '0'
        }

        sessionStorage.setItem('cep', cep)
        sessionStorage.setItem('number', number)

        const viabilityReponse = await axios.get(process.env.availableTechnologies, { headers: {'cep': cep, 'number': number} })
        sessionStorage.setItem(AVAILABLE_TECHNOLOGIES_RESPONSE_SESSION_NAME, viabilityReponse.data);
        const response = jwt.decode(viabilityReponse.data)

        if (response?.timeout_feature_flag) {
            console.error('The FeatureFlag API did not respond because of a timeout')
        }

        if (response?.error_feature_flag) {
            console.error(
                'Sorry, there was a problem with the featureFlag request.',
                {
                    status: response.error_feature_flag?.status,
                    data: response.error_feature_flag?.data
                }
            )
        }

        return response.data;

    } catch (error) {

        if (error.response.data?.errors?.code === "404-001") {
            const resp = error.response.data;
            resp.technologies = [{
                gpon: false,
                name: 'Satellite',
                internet: false,
                phone: false,
                tv: false
            }]
            resp.regionId = '021'
            return resp
        }

        return error.response ? error.response.data : error
    }
}

const findAttribute = (obj, attribute) => {
    if (obj[attribute]) {
        return `${obj[attribute]}`;
    }
    
    for (let key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            let result = findAttribute(obj[key], attribute);
            if (result) {
                return result;
            }
        }
    }
    
    return null;
};

const mountLeadObject = (ids, formData, viabilityInfo, ACN) => {
    const productType = formData.productType
    const stProduct = sessionStorage.getItem(`${productType}-product`)
    const sid = localStorage.getItem('session_id') || '';
    const gaUserId = document.cookie.match(/_ga=(.+?);/)[1].split('.').slice(-2).join(".");
    const product = JSON.parse(stProduct)
    let catalog = 'net'

    if (viabilityInfo?.technologies) {
        const hasCable_ = viabilityInfo.technologies.find(x => x.name === 'Cable')
        catalog = hasCable_ ? 'net' : 'clarotv'
    }

    let leadObj = {
        "user": {
            "name": formData.name,
            "email": formData.email,
            "cpf": formData.cpf.replace(/[.-]+/g, ""),
            "rg": formData.rg,
            "motherName": formData.motherName,
            "other": {
                "WhatsApp": formData.whatsapp,
                "gaSessionId": sid,
                "clientId": gaUserId
            },
            "phone": {
                "area": formData.phone.substr(0, 2),
                "number": formData.phone.substr(2)
            },
            "additionalPhone": {
                "area": formData.phone.substr(0, 2),
                "number": formData.phone.substr(2)
            },
        },
        "catalog": catalog,
        "originId": "",
        "mediaChannel": "desktop",
        "salesChannel": "net",
        "products": [
            {
                ...product,
                "type": "tv",
                "price": 6990,
                "extras": [
                    {
                        "id": 9998,
                        "name": "Recursos",
                        "options": [
                            {
                                "id": 709,
                                "name": "Replay TV",
                                "price": 0,
                                "categoryId": ""
                            },
                            {
                                "id": 712,
                                "name": "Acesso a 2 telas simultâneas",
                                "price": 0,
                                "categoryId": ""
                            },
                            {
                                "id": 713,
                                "name": "Download para assistir offline",
                                "price": 0,
                                "categoryId": ""
                            }
                        ]
                    }
                ],
                "deal": null,
                "tags": [
                    "inibicaoagenda",
                    "gpon",
                    "claroapp",
                    "598"
                ],
                "hasContract": true,
                "registrationFee": {
                    "value": 0,
                    "inAdvance": false,
                    "payments": 0
                }
            }
        ],
        "regionId": "007",
        "payment": {},
        "schedule": [],
        "installationAddress": {
            "number": formData.number === '' ? 0 : formData.number,
            "type": "R",
            "reference": ""
        },
        "installationFee": 0
    }

    if (formData.withoutNumber === true) {
        leadObj.installationAddress.number = '0'
    }

    if (formData.birthdate) {
        const arrayDate = formData.birthdate.split('/');
        leadObj.user.birthdate = arrayDate[2] + '-' + arrayDate[1] + '-' + arrayDate[0];
    }
    
    if (viabilityInfo.cidade && viabilityInfo.uf) {
        leadObj.installationAddress.city = viabilityInfo.cidade
        leadObj.installationAddress.state = viabilityInfo.uf
        sessionStorage.setItem("city", viabilityInfo.cidade)
        sessionStorage.setItem("uf", viabilityInfo.uf)
    }
    if (viabilityInfo.logradouro && viabilityInfo.bairro) {
        leadObj.installationAddress.district = viabilityInfo.bairro
        leadObj.installationAddress.address = viabilityInfo.logradouro
    }
    if (formData.cep) {
        leadObj.installationAddress.zipcode = formData.cep.replace('-', '')
    }

    if (leadObj.user) {
        sessionStorage.setItem("user", JSON.stringify(leadObj.user))
    }

    if(ACN){
        leadObj.customerOrigin = "base-movel"
    }

    return leadObj
}
